import React, { useState, FC } from "react";
import { Table, Tooltip } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useScmSaleRoDetailModel } from "../scmSaleRoModel";
import { ISCMSaleRoGoodsDetail } from "../scmSaleRoType";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { formatNum } from "@/utils/utils";
import { useVrmPurchaseRoDetailsModel } from "@/views/vrmBill/vrmBillPurchaseRo/vrmBillPurchaseRoModel"


export const TableBox: FC<RouterParamType> = () => {
    const { lookRoGoodsList, getTreeNodeName } = useScmSaleRoDetailModel();
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const { goToSaleDetail } = useVrmPurchaseRoDetailsModel()
    const { getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { branch } = detailsInfo

    // 供应链销售退货单详情列表
    const columns: ColumnsType<ISCMSaleRoGoodsDetail> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            align: "center",
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '销售单号',
            width: 190,
            dataIndex: 'saleCode',
            fixed: "left",
            render: (t) => <Tooltip placement="topLeft" title={t} arrowPointAtCenter>
                <p className="ellipsis click-span" onClick={(e) => { e.stopPropagation(); goToSaleDetail(t, branch) }}>{t}
                </p></Tooltip>
        }, {
            title: '厂家单号',
            width: 160,
            dataIndex: 'wsCode',
        }, {
            title: '商品编码',
            width: 160,
            dataIndex: 'materialCode',
        }, {
            title: '商品名称',
            width: 160,
            dataIndex: 'materialName',
            render: (text: string) => <p className="ellipsis" title={text}>{text}</p>
        }, {
            title: '销售数量',
            width: 100,
            dataIndex: 'saleNum',
        }, {
            title: '赠品数量',
            width: 100,
            dataIndex: 'giftsNum',
        }, {
            title: '已退货数量',
            width: 100,
            dataIndex: 'returnedNum',
        }, {
            title: '开单数量',
            width: 100,
            dataIndex: 'num',
            // editable: !(mode === "edit" && status === DictCodeEnmu.SALE_RETURN_STATUS_SUBMIT),

        }, {
            title: '退货单价',
            width: 136,
            dataIndex: 'price',
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '下浮',
            width: 100,
            dataIndex: 'discountRate',
        }, {
            title: '总计',
            width: 136,
            dataIndex: 'amount',
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '驳回数量',
            width: 100,
            dataIndex: 'rejectNum',
            render: (text: string) => <span className={+text > 0 ? "color-red" : ""}>{text}</span>
        }, {
            title: '确认数量',
            width: 100,
            dataIndex: 'confirmNum',
        }, {
            title: '入库总计',
            width: 136,
            dataIndex: 'stockIoAmount',
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '入库员',
            width: 100,
            dataIndex: 'stockIoStaff',
            render: (text: string) => getTreeNodeName(text)
        }, {
            title: '仓库',
            width: 120,
            dataIndex: 'warehouseName',
        }, {
            title: '货位',
            width: 120,
            dataIndex: 'shelfCode',
        }, {
            title: '替换编号',
            width: 120,
            dataIndex: 'replaceCode',
        }, {
            title: '商品类型',
            width: 120,
            dataIndex: 'typeName',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
        }
    ];
    return (
        <YhBox title="" style={{ marginBottom: "75px" }}>
            <Table
                rowKey={record => record.key}
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={{
                    selectedRowKeys: selectedRowKeys, //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: ISCMSaleRoGoodsDetail[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[]);
                    }
                }}
                columns={columns}
                dataSource={lookRoGoodsList}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}